import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
export function FinalCTA() {
  return <section className="bg-arena flex flex-col items-center justify-center text-center px-6 md:px-16 pt-[80px] md:pt-[120px] pb-[80px] md:pb-[120px]" data-id="element-75" data-mp="qae7000e64ds">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col items-center max-w-[680px]" data-id="element-76" data-mp="lbum82xjayn0">
        <span className="font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-5" data-id="element-77" data-mp="2k1sg6an59e8">
          HABLEMOS
        </span>

        <h2 className="font-display text-[34px] md:text-[50px] font-medium text-carbon leading-[1.12] tracking-tightest mb-4 max-w-[640px]" data-id="element-78" data-mp="3ayaeevinr1xf">
          ¿Qué parte de tu empresa podría funcionar mejor?
        </h2>

        <p className="font-body text-[17px] md:text-[19px] text-carbon/55 max-w-[480px] mb-10" data-id="element-79" data-mp="33e2qxc2gwm9r">
          Cuéntanos qué quieres mejorar. Revisamos tu proceso y definimos
          qué tiene sentido construir.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3" data-id="element-80" data-mp="3d45kpehey495">
          <a href={getWhatsAppLink('Hola, equipo de ORIGEN. Quiero mejorar mi presencia digital.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-medium text-[15px] px-[28px] py-[15px] rounded-[6px] hover:bg-verde-hover transition-colors duration-200" data-id="element-81" data-mp="2gdmve6ncmne4">
            Mejorar mi presencia digital <ArrowRight size={17} className="ml-2" data-id="element-82" data-mp="4nkjijv0wfgl" />
          </a>
          <a href={getWhatsAppLink('Hola, equipo de ORIGEN. Quiero automatizar mi empresa.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-transparent text-carbon border border-carbon/20 font-display font-medium text-[15px] px-[28px] py-[15px] rounded-[6px] hover:border-carbon/40 transition-colors duration-200" data-id="element-83" data-mp="9mnmlyrg0blx">
            Automatizar mi empresa <ArrowRight size={17} className="ml-2" data-id="element-84" data-mp="2xdxu76oykop1" />
          </a>
        </div>

        <p className="font-body text-[13px] text-carbon/40 mt-5" data-id="element-85" data-mp="2xbts8uamdzre">
          Sin compromiso. Primero entendemos el problema.
        </p>

        <div className="mt-16 flex flex-col items-center" data-id="element-86" data-mp="37499fpe3ekb8">
          <div className="w-[60px] h-px bg-carbon/15 mb-4" data-id="element-87" data-mp="375u3zf0eq393" />
          <span className="font-body text-[12px] text-carbon/30" data-id="element-88" data-mp="32bzji9cz9k8y">
            ORIGEN · Colombia · 2026
          </span>
        </div>
      </motion.div>
    </section>;
}